import { useContext } from 'react';

import DataContext from '../../../store/dataContext';

const useAuthentication = () => {
  const { isLoggedIn, setIsLoggedIn, updateWasLoggedIn } = useContext(DataContext);

  const setAuthenticatedUser = isUserAuthenticated => {
    setIsLoggedIn(isUserAuthenticated);
    updateWasLoggedIn(isUserAuthenticated);
  };

  return { isLoggedIn, setAuthenticatedUser };
};

export default useAuthentication;
